import Vue from 'vue'
import store from '@/store'
import { ROLES } from '@/constants'

Vue.mixin({
  computed: {
    isAuth () {
      return store.getters['auth/isAuth']
    },
    user () {
      return store.getters['auth/user']
    },
    roles () {
      return ROLES
    }
  },
  methods: {
    isRole (role) {
      return this.user.role === role
    }
  }
})
